import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { DomainRoles, Domains } from "../models/DomainInfo";
import { ToastrService } from "ngx-toastr";
import { UserRightsService } from "./user-rights/user-rights.service";

@Injectable({
	providedIn: "root",
})
export class UserRightsAuthGuardService {
	constructor(
		private auth: UserRightsService,
		private toastService: ToastrService,
		private router: Router,
		private domains: Domains,
		private domainRoles: DomainRoles,
	) { }
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const routeParts = state.url.split("/");
		const accessObject = this.auth.GetUserAccessRoles();
		if (!accessObject) {
			return false;
		}

		if (routeParts.length >= 2) {
			let allowed = false;
			switch (routeParts[1]) {
				case Domains.PORTAL_DOMAIN:
					allowed = accessObject.HasPortalAccess();
					break;
				case Domains.CDR_DOMAIN:
					allowed = accessObject.HasCDRAccess() && this.auth.HasCDRAccess();
					break;
				case Domains.KEEPALIVE_DOMAIN:
					allowed = accessObject.HasKeepAliveAccess() && this.auth.HasKeepAliveAccess();
					break;
				case Domains.MIKROTIK_DOMAIN:
					allowed = accessObject.HasMikrotikAccess() && this.auth.HasMikrotikAccess();
					break;
				case Domains.RELAY_DOMAIN:
					allowed = accessObject.HasRelayAccess() && this.auth.HasRelayAccess();
					break;
				case Domains.REPORTS_DOMAIN:
					if (routeParts.length >= 3) {
						if (routeParts[2] == Domains.CDR_DOMAIN) {
							allowed = accessObject.IsCDRReporting() && this.auth.HasCDRAccess();
						} else if (routeParts[2] == Domains.KEEPALIVE_DOMAIN) {
							allowed = accessObject.IsKeepAliveReporting() && this.auth.HasKeepAliveAccess();
						} else if (routeParts[2] == Domains.MIKROTIK_DOMAIN) {
							allowed = accessObject.IsMikrotikReporting() && this.auth.HasMikrotikAccess();
						} else if (routeParts[2] == Domains.RELAY_DOMAIN) {
							allowed = accessObject.IsRelayReporting() && this.auth.HasRelayAccess();
						}
					}
					break;
				case Domains.TELTONIKA_DOMAIN:
					allowed = accessObject.HasTeltonikaAccess() && this.auth.HasTeltonikaAccess();
					break;
				case Domains.CONTRACTORS_DOMAIN:
					allowed = accessObject.HasContractorsAccess() && this.auth.HasContractorsAccess();
					break;
			}

			if (!allowed) {
				this.toastService.error("Access to this module has not been set up.", "No Access", { timeOut: 3500 });
			}

			return allowed;
		} else {
			console.log("No access to inner routes - probably called at login or some other root page.");
		}

		// if (currUser["ImpersonatedUser"] != null) {
		//   if (currUser["ImpersonatedUser"]["AccessRevoked"]) {
		//     this.toastService.info("Please Login", 8000, "Your access for this group has been revoked.");
		//     this.auth.Logout();
		//     return false;
		//   }
		// }

		// if (currUser["AccessRevoked"] != null && currUser["AccessRevoked"]) {
		//   this.toastService.info("Please Login", 8000, "Your access for this group has been revoked.");
		//   this.auth.Logout();
		//   return false;
		// }

		return false;
	}
}
